import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

type Severity = 'success' | 'info' | 'warn' | 'error';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly messageService = inject(MessageService);

  private notify(severity: Severity, summary: string, detail: string): void {
    setTimeout(() => {
      this.messageService.add({ severity, summary, detail, life: 4000 });
    }, 100);
  }

  showSuccess(message: string, title = 'Éxito'): void {
    this.notify('success', title, message);
  }

  showError(message: string, title = 'Error'): void {
    this.notify('error', title, message);
  }

  showInfo(message: string, title = 'Información'): void {
    this.notify('info', title, message);
  }

  showWarn(message: string, title = 'Advertencia'): void {
    this.notify('warn', title, message);
  }
}
